const accessToken = '72c0f7fbe74f4675af7646a4974f9317'
const rollbarOptions = environment => {
  return {
    verbose: true,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: environment
    }
  }
}

export { accessToken, rollbarOptions }
